export function phoneMask(phoneValue) {
  phoneValue = phoneValue.replace(/\D/g, '')
  phoneValue = phoneValue.replace(/(\d{2})(\d)/, '($1) $2') // formatação do DDD
  phoneValue = phoneValue.replace(/(\d{4,5})(\d)/, '$1-$2') // formatação do número

  return phoneValue
}
